import moveToStore from '../store/store';
import { mutatorAction } from 'satcheljs';
/**
 * Sets the initial state of new folder view state
 */
export default mutatorAction('setInitialNewFolderViewState', function setInitialNewFolderViewState() {
    moveToStore.newFolderViewState = {
        folderText: '',
        isInvalid: false,
    };
});
//# sourceMappingURL=setInitialNewFolderViewState.js.map